import { render, staticRenderFns } from "./ExerciseGuide.vue?vue&type=template&id=79364675&scoped=true&"
import script from "./ExerciseGuide.vue?vue&type=script&lang=js&"
export * from "./ExerciseGuide.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseGuide.vue?vue&type=style&index=0&id=79364675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79364675",
  null
  
)

export default component.exports